export default class DragObj {
  start_x0 = 0;
  start_y0 = 0;
  start_x1 = 0;
  start_y1 = 0;
  state = false; //记录鼠标按键是否松开
  delta_x = 0; //相对于原始位置的横向偏移量
  delta_y = 0; //相对于原始位置的纵向偏移量
  target: any;
  move_item: any;
  moveStartFun: any;
  movingFun;
  moveEndFun;
  constructor(target, move_item) {
    this.target = target; //被移动的dom元素
    this.move_item = move_item; //接受触发移动行为的dom元素,一般为模态框的头部
    this.init();
  }

  init() {
    this.move_item.style.cursor = 'move';
    this.bindEvent();
  }

  destroy() {
    this.move_item.removeEventListener('dragstart', this.moveStartFun);
    document.removeEventListener('drag', this.movingFun);
    document.removeEventListener('dragend', this.moveEndFun);
  }

  bindEvent() {
    this.moveStartFun = this.moveStart.bind(this);
    this.movingFun = this.moving.bind(this);
    this.moveEndFun = this.moveEnd.bind(this);
    this.move_item.addEventListener('dragstart', this.moveStartFun);
    document.addEventListener('drag', this.movingFun);
    document.addEventListener('dragend', this.moveEndFun);
  }

  moveStart(e) {
    e.stopPropagation();
    this.state = true; //检测鼠标是否处于按下的状态
    this.start_x0 = e.pageX;
    this.start_y0 = e.pageY;
  }

  moving(e) {
    //鼠标移动时的默认操作
    e.stopPropagation();
    e.preventDefault();
    if (!this.state) {
      return false;
    }

    this.start_x1 = e.pageX;
    this.start_y1 = e.pageY;
  }

  moveEnd(e) {
    if (!this.state) {
      return false;
    }
    this.state = false;
    this.delta_x = e.pageX;
    this.delta_y = e.pageY;
    console.log(e);
    this.render();
  }

  render() {
    console.log(this.start_x0, this.delta_x);
    this.target.style.transform = `translate(${
      this.start_x0 * 2 - this.delta_x
    }px,${this.start_y0 * 2 - this.delta_y}px)`;
  }
}

// destroy() {
//   this.move_item.removeEventListener('dragstart', this.moveStartFun);
//   document.removeEventListener('drag', this.movingFun);
//   document.removeEventListener('dragend', this.moveEndFun);
// }

// bindEvent() {
//   this.moveStartFun = this.moveStart.bind(this);
//   this.movingFun = this.moving.bind(this);
//   this.moveEndFun = this.moveEnd.bind(this);
//   this.move_item.addEventListener('dragstart', this.moveStartFun);
//   document.addEventListener('drag', this.movingFun);
//   document.addEventListener('dragend', this.moveEndFun);
// }

// destroy() {
//   this.move_item.removeEventListener('mousedown', this.moveStartFun);
//   document.removeEventListener('mousemove', this.movingFun);
//   document.removeEventListener('mouseup', this.moveEndFun);
// }

// bindEvent() {
//   this.moveStartFun = this.moveStart.bind(this);
//   this.movingFun = this.moving.bind(this);
//   this.moveEndFun = this.moveEnd.bind(this);
//   this.move_item.addEventListener('mousedown', this.moveStartFun);
//   document.addEventListener('mousemove', this.movingFun);
//   document.addEventListener('mouseup', this.moveEndFun);
// }

//onMouseDown

// export default class DragObj {
//   start_x0 = 0;
//   start_y0 = 0;
//   start_x1 = 0;
//   start_y1 = 0;
//   state = false; //记录鼠标按键是否松开
//   delta_x = 0; //相对于原始位置的横向偏移量
//   delta_y = 0; //相对于原始位置的纵向偏移量
//   target: any;
//   move_item: any;
//   moveStartFun: any;
//   movingFun;
//   moveEndFun;
//   constructor(target, move_item) {
//     this.target = target; //被移动的dom元素
//     this.move_item = move_item; //接受触发移动行为的dom元素,一般为模态框的头部
//     this.init();
//   }

//   init() {
//     this.move_item.style.cursor = 'move';
//     this.bindEvent();
//   }

//   destroy() {
//     this.move_item.removeEventListener('mousedown', this.moveStartFun);
//     document.removeEventListener('mousemove', this.movingFun);
//     document.removeEventListener('mouseup', this.moveEndFun);
//   }

//   bindEvent() {
//     this.moveStartFun = this.moveStart.bind(this);
//     this.movingFun = this.moving.bind(this);
//     this.moveEndFun = this.moveEnd.bind(this);
//     this.move_item.addEventListener('mousedown', this.moveStartFun);
//     document.addEventListener('mousemove', this.movingFun);
//     document.addEventListener('mouseup', this.moveEndFun);
//   }

//   moveStart(e) {
//     e.stopPropagation();
//     this.state = true; //检测鼠标是否处于按下的状态
//     this.start_x0 = e.pageX;
//     this.start_y0 = e.pageY;
//   }

//   moving(e) {
//     //鼠标移动时的默认操作
//     e.stopPropagation();
//     e.preventDefault();
//     if (!this.state) {
//       return false;
//     }

//     this.start_x1 = e.pageX;
//     this.start_y1 = e.pageY;
//     this.render();
//   }

//   moveEnd(e) {
//     if (!this.state) {
//       return false;
//     }
//     this.state = false;
//     this.delta_x = this.start_x1 - this.start_x0 + this.delta_x;
//     this.delta_y = this.start_y1 - this.start_y0 + this.delta_y;
//   }

//   render() {
//     this.target.style.transform = `translate(${
//       this.start_x1 - this.start_x0 + this.delta_x
//     }px,${this.start_y1 - this.start_y0 + this.delta_y}px)`;
//   }
// }
